import React from "react";
import {
  Button,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  Text,
  IconButton,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description?: string;
  chatCountDescription?: string;
  deleteButtonTitle: string;
  cancelButtonTitle: string;
}

export const ModalDelete: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  chatCountDescription,
  deleteButtonTitle = "Confirm",
  cancelButtonTitle = "Cancel",
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="white"
        borderRadius="20px"
        maxH="500px"
        maxW="500px"
        marginTop="auto"
        marginBottom="auto"
        padding="20px"
        gap="32px"
        justifyContent={"center"}
        alignItems={"center"}
        position="relative"
        overflow="visible"
      >
        <IconButton
          aria-label="Close modal"
          icon={<CloseIcon />}
          onClick={onClose}
          position="absolute"
          top="12px"
          right="12px"
          size="sm"
          borderRadius="full"
          zIndex={10}
          color="#40464B"
          bg="white"
          boxShadow="sm"
        />
        <Flex
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          gap="32px"
          width="100%"
        >
          <Flex
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
            gap="8px"
            width="100%"
          >
            <Text
              fontSize="24px"
              fontWeight={600}
              fontFamily={"Poppins"}
              textAlign="center"
            >
              {title}
            </Text>
            {chatCountDescription ? (
              <Text
                fontFamily={"Poppins"}
                fontSize="16px"
                fontWeight={400}
                textAlign="center"
                color="#798692"
              >
                {chatCountDescription}
              </Text>
            ) : description ? (
              <Text
                fontFamily={"Poppins"}
                fontSize="16px"
                fontWeight={400}
                textAlign="center"
                color="#798692"
              >
                {description}
              </Text>
            ) : null}
          </Flex>
          <Flex
            justifyContent={"flex-end"}
            alignItems={"center"}
            gap={"8px"}
            width={"100%"}
          >
            <Button
              variant="outline"
              borderRadius="10px"
              colorScheme="gray"
              width="84px"
              height="39px"
              onClick={onClose}
            >
              {cancelButtonTitle}
            </Button>
            <Button
              width="84px"
              height="39px"
              backgroundColor="#1819B4"
              color="white"
              onClick={onConfirm}
              _hover={{ backgroundColor: "#1415A0" }}
            >
              {deleteButtonTitle}
            </Button>
          </Flex>
        </Flex>
      </ModalContent>
    </Modal>
  );
};
